import {Validator} from 'vee-validate';
import {BasicSelect} from 'vue-search-select';
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import CONSTANT from '../../../../../shared/constants/constant';
import DatePicker from 'vue2-datepicker';
import CustomExpandableTable from './../../../../../shared/components/customExpandableTable';
import Pagination from './../../../../../shared/components/pagination';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import Util from './../../../../../shared/util/util';
import DamageServices from './.././../../../services/firstAndLastmilemanagement.service'
const moment = require('moment');

export default {
  name: 'damagempsreason',
  components: {
    BasicSelect,
    DatePicker,
    CustomExpandableTable,
    Pagination,
    Treeselect,
    VueElementLoading,
    Util,
    DamageServices
  },
  props:['childData'],
  data() {
    return {
      pageLimit:CONSTANT.PER_PAGE_DATA,
      tableColumn: ['MPS','Damage Hub Name','Reasons','Description','Damage Mark Date','Action'],
      innerTableColumn: ['Assigned Zones'],
      tableItems: [],
      totalCount:0,
      offset: 0,
      ShowDamageMPSImages:false,
      isImageLoading:false,
      imagearray:[],
      image:"",
      caption:"MPS Damage Image",
    }
  },
  computed: {},
  async mounted() {
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.userName = userdetail.email;
    this.getDamageDetails()
  },
  methods: {
    async getCustomTableEvent(id){
      if (id.actionType == "isviewimage") {
        this.imagearray = [];
        this.ShowDamageMPSImages = true;
        this.isImageLoading = true;
        let input = {
          "id":id.id
        };
        let resultImage = await DamageServices.GetDamageMPSImages(input);
        if (resultImage.data.code == 200) {
          resultImage.data.data.damageimages.forEach((obj) => {
            this.imagearray.push(obj);
          });
        } else {
          this.imagearray = [];
        }
        this.isImageLoading = false;
      }
    },

    async getDamageDetails(){
      try{
        if(this.childData.mpsdetails){
          this.tableItems = this.childData.mpsdetails.map((el,index)=>{
            return {
            'id':el.id,
            'MPS':el.mps,
            'Damage Hub Name':el.markdamagehubname,
            'Reasons':el.damagereasons,
            'Description':el.description,
            'Damage Mark Date':el.createddate
            }
          })
        }else{
          this.tableItems = []
        }
      }catch(err){
        console.log(err);
      }
    },
    closeDamageMPSImages(){
      this.imagearray = []
      this.mps = ''
      this.reasonArr = []
      this.ShowDamageMPSImages =false;
    },
    openImage(image) {
      this.image = image
      this.$nextTick(() => {
        let modal = document.getElementById('myModalImg' + image);
        var img = document.getElementById('imgid' + image);
        var modalImg = document.getElementById("img" + image);
        var captionText = document.getElementById("captionImg" + this.caption);
        modal.style.display = "block";
        modalImg.src = image;
        captionText.innerHTML = this.caption;
        this.ShowDamageMPSImages =false;
			})
    },
    closemodal(id) {
      let modal = document.getElementById(id);
      modal.style.display = "none";
      this.ShowDamageMPSImages =true;
    },
    fileview(index){
      var link = document.createElement('a');
      link.href = index;
      link.setAttribute('target','_blank');
      window.open(index, '_blank');
      link.remove();
      return true;
    },
  }
}



// WEBPACK FOOTER //
// ./src/modules/firstAndLastmilemanagement/views/DamageMPS/markdamageMPSListing/DamageMPSDetails/damagempsdetails.component.js